var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "form",
    attrs: {
      "label-width": "80px",
      "label-suffix": ":",
      "rules": _vm.rules,
      "model": _vm.role
    }
  }, [(!_vm.noSave) ? _c('el-form-item', {
    attrs: {
      "label": "角色",
      "prop": "roleDescription"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.role.roleDescription),
      callback: function($$v) {
        _vm.$set(_vm.role, "roleDescription", $$v)
      },
      expression: "role.roleDescription"
    }
  })], 1) : _vm._e(), (!_vm.noSave) ? _c('el-form-item', {
    attrs: {
      "label": "城市",
      "prop": "cityGuids"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "filterable",
      "multiple": "multiple"
    },
    model: {
      value: (_vm.role.cityGuids),
      callback: function($$v) {
        _vm.$set(_vm.role, "cityGuids", $$v)
      },
      expression: "role.cityGuids"
    }
  }, _vm._l((_vm.cityList), function(city) {
    return _c('el-option', {
      key: city.cityGuid,
      attrs: {
        "label": city.cityName,
        "value": city.cityGuid
      }
    })
  }))], 1) : _vm._e(), _c('el-form-item', {
    attrs: {
      "label": "权限"
    }
  }, [_c('el-tree', {
    ref: "tree",
    attrs: {
      "props": _vm.props,
      "data": _vm.permissionList,
      "show-checkbox": "show-checkbox",
      "default-expanded-keys": _vm.expandedKeys,
      "node-key": "id"
    }
  })], 1), (!_vm.noSave) ? _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("保存")])], 1) : _vm._e()], 1)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-79d8e4d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79d8e4d4","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/system/permissionTree.vue
// module id = hwLb
// module chunks = 1